import { getCalendarJobTypeLeftColumnLabel } from './get-calendar-job-type-left-column-label';
import type { CalendarJobTypeLeftColumnLabel } from './get-calendar-job-type-left-column-label';

type CalendarPlanningDepartmentDisplaySource = {
  companyName: string;
  name: string;
  branchOffice: { name: string };
};

export const isOtherCompanyDepartment = (
  department: Pick<CalendarPlanningDepartmentDisplaySource, 'companyName'>,
  ownCompanyName: string
): boolean => ownCompanyName.length > 0 && department.companyName !== ownCompanyName;

export const getCalendarDepartmentJobTypeLeftColumnLabel = (options: {
  department: CalendarPlanningDepartmentDisplaySource;
  ownCompanyName: string;
  isLimitedCompany: boolean;
  showCompanyNameInCalendar: boolean;
}): CalendarJobTypeLeftColumnLabel | undefined => {
  const { department, ownCompanyName, isLimitedCompany, showCompanyNameInCalendar } = options;

  if (isLimitedCompany) {
    return undefined;
  }

  if (showCompanyNameInCalendar && ownCompanyName.length > 0) {
    return getCalendarJobTypeLeftColumnLabel(department, ownCompanyName);
  }

  return undefined;
};

export const shouldHideCalendarDepartmentHeader = (options: {
  isLimitedCompany: boolean;
  showCompanyNameInCalendar: boolean;
  department: Pick<CalendarPlanningDepartmentDisplaySource, 'companyName'>;
  ownCompanyName: string;
}): boolean => {
  const { isLimitedCompany, showCompanyNameInCalendar, department, ownCompanyName } = options;

  if (isLimitedCompany) {
    return true;
  }

  return showCompanyNameInCalendar && ownCompanyName.length > 0;
};
